// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-control.is-active[data-v-2ff73832]{border:1px solid #0a72cc;color:#085395}.apply-button[data-v-2ff73832]{height:2.5rem;vertical-align:bottom;margin-left:.25rem}.apply-icon[data-v-2ff73832]{transform:rotate(-90deg);display:inline-block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
